import {hAreaCodeEnum} from 'hiya-common/src/reducers/env'
import {useSelector} from 'react-redux'
import {HiyaVerHost} from 'hiya-common/src/constant'
import {ModelType} from '../../serve'

// 0-普通抽奖；1-高级抽奖
export enum TAB_KEYS {
  初级老虎机 = '0',
  高级老虎机 = '1',
}

export const RecordType = {
  [TAB_KEYS.初级老虎机]: 'normal_records',
  [TAB_KEYS.高级老虎机]: 'high_records',
}

// 状态:0:未完成;1:完成未领取奖励;2:完成并领取奖励
export enum JobStatusTypeEnum {
  未完成 = 0,
  已完成,
  完成并领取奖励,
}

const logicIds = {
  // 抽奖系统
  [ModelType.抽奖系统]: {
    [hAreaCodeEnum.vi]: {
      [TAB_KEYS.初级老虎机]: 1701916043,
      [TAB_KEYS.高级老虎机]: 1701916042,
    },
    [hAreaCodeEnum.tp]: {
      [TAB_KEYS.初级老虎机]: 1701916043,
      [TAB_KEYS.高级老虎机]: 1701916042,
    },
    [hAreaCodeEnum.pk]: {
      [TAB_KEYS.初级老虎机]: 1701916043,
      [TAB_KEYS.高级老虎机]: 1701916042,
    },
    [hAreaCodeEnum.hk]: {
      [TAB_KEYS.初级老虎机]: 1701916043,
      [TAB_KEYS.高级老虎机]: 1701916042,
    },
    [hAreaCodeEnum.hi]: {
      [TAB_KEYS.初级老虎机]: 1701916043,
      [TAB_KEYS.高级老虎机]: 1701916042,
    },
    [hAreaCodeEnum.id]: {
      [TAB_KEYS.初级老虎机]: 1701916043,
      [TAB_KEYS.高级老虎机]: 1701916042,
    },
  },
  // 阶段任务系统
  [ModelType.阶段任务系统]: {
    [hAreaCodeEnum.vi]: {
      [TAB_KEYS.初级老虎机]: 1701916047,
      [TAB_KEYS.高级老虎机]: 1701916048,
    },
    [hAreaCodeEnum.tp]: {
      [TAB_KEYS.初级老虎机]: 1701916047,
      [TAB_KEYS.高级老虎机]: 1701916048,
    },
    [hAreaCodeEnum.pk]: {
      [TAB_KEYS.初级老虎机]: 1701916047,
      [TAB_KEYS.高级老虎机]: 1701916048,
    },
    [hAreaCodeEnum.hi]: {
      [TAB_KEYS.初级老虎机]: 1701916047,
      [TAB_KEYS.高级老虎机]: 1701916048,
    },
    [hAreaCodeEnum.hk]: {
      [TAB_KEYS.初级老虎机]: 1701916047,
      [TAB_KEYS.高级老虎机]: 1701916048,
    },
    [hAreaCodeEnum.id]: {
      [TAB_KEYS.初级老虎机]: 1701916047,
      [TAB_KEYS.高级老虎机]: 1701916048,
    },
  },
}
const useLogicId = ({modeType}: {modeType: ModelType}) => {
  const {h_area_code} = useSelector((s) => s.env.deviceinfo)
  return logicIds[modeType][h_area_code] || 0
}
export {useLogicId}

const getImgSrc = (key, getImages = require.context('./images', false)) => {
  const rewardsPng = getImages
  const src = rewardsPng.keys().find((v) => {
    return v.indexOf(key) !== -1
  })
  return src && rewardsPng(src)
}

export const getGameUrl = (type) =>
  `hiya://openWindow?fullscreen=2&external=0&need_user_info=1&bg_clear=1&disable_native_gesture=1&url=${HiyaVerHost}/game/${type}`

const getGreedyProJumpUrl = (h_area_code) => {
  if (h_area_code === hAreaCodeEnum.ar || h_area_code === hAreaCodeEnum.tr) {
    return getGameUrl('GreedyPro/1001')
  }
  if (h_area_code === hAreaCodeEnum.hi || h_area_code === hAreaCodeEnum.pk) {
    return getGameUrl('GreedyPro/1002')
  }
  if (h_area_code === hAreaCodeEnum.id) {
    return getGameUrl('GreedyPro/1003')
  }
  return getGameUrl('GreedyPro/1004')
}
const gameList = (h_area_code) => {
  return [
    {
      jumpUrl: getGameUrl('GreedyHiya'),
      iconUrl: getImgSrc(
        'GreedyHiyaImg',
        require.context('./images/game', false)
      ),
      type: 1,
    },
    {
      jumpUrl: getGameUrl('GreedyBox'),
      iconUrl: getImgSrc(
        'GreedyBoxImg',
        require.context('./images/game', false)
      ),
      type: 5,
    },
    {
      jumpUrl: getGreedyProJumpUrl(h_area_code),
      iconUrl: getImgSrc(
        'GreedyProImg',
        require.context('./images/game', false)
      ),
      type: 2,
    },
    {
      jumpUrl: `hiya://openWindow?fullscreen=2&disable_native_gesture=1&bg_clear=1&alert_h_ratio=0.8&external=0&other_info=%7B%22from%22:%22function_bar%22%7D&third_game_type=1&need_user_info=1&url=${HiyaVerHost}/gameTP/FishingStar`,
      iconUrl: getImgSrc(
        'FishingStar',
        require.context('./images/game', false)
      ),
      type: 7,
    },
    {
      jumpUrl: getGameUrl('LuckySlot'),
      iconUrl: getImgSrc('SlotsImg', require.context('./images/game', false)),
      type: 3,
    },
    {
      jumpUrl: getGameUrl('GreedyRocket'),
      iconUrl: getImgSrc(
        'GreedyRocket',
        require.context('./images/game', false)
      ),
      type: 8,
    },
    {
      jumpUrl: getGameUrl('roulette'),
      iconUrl: getImgSrc(
        'RouletteImg',
        require.context('./images/game', false)
      ),
      type: 4,
    },
    {
      jumpUrl: getGameUrl('TeenPatti'),
      iconUrl: getImgSrc('TeenPatti', require.context('./images/game', false)),
      type: 6,
    },
  ]
}
export const useGameList = () => {
  const {h_area_code} = useSelector((s) => s.env.deviceinfo)
  return gameList(h_area_code)
}

// 老虎机单个icon的高度
export const SymbolHeight = 58

// 老虎机转动持续时长
export const SpinDuration = [3000, 4000, 5000]

// 老虎机转动圈数
export const SpinCycles = [3, 4, 5]

export enum ModalTypeEnum {
  奖励记录,
  奖励弹窗,
}

export enum LotteryStatusEnum {
  空奖励,
  抽中,
}

export const TitleImg = {
  [hAreaCodeEnum.vi]: {
    [LotteryStatusEnum.抽中]: getImgSrc(
      'vi恭喜',
      require.context('./images/title', false)
    ),
    [LotteryStatusEnum.空奖励]: getImgSrc(
      'vi抱歉',
      require.context('./images/title', false)
    ),
  },
  [hAreaCodeEnum.tp]: {
    [LotteryStatusEnum.抽中]: getImgSrc(
      'tp恭喜',
      require.context('./images/title', false)
    ),
    [LotteryStatusEnum.空奖励]: getImgSrc(
      'tp抱歉',
      require.context('./images/title', false)
    ),
  },
  [hAreaCodeEnum.pk]: {
    [LotteryStatusEnum.抽中]: getImgSrc(
      'tp恭喜',
      require.context('./images/title', false)
    ),
    [LotteryStatusEnum.空奖励]: getImgSrc(
      'tp抱歉',
      require.context('./images/title', false)
    ),
  },
  [hAreaCodeEnum.id]: {
    [LotteryStatusEnum.抽中]: getImgSrc(
      'id恭喜',
      require.context('./images/title', false)
    ),
    [LotteryStatusEnum.空奖励]: getImgSrc(
      'id抱歉',
      require.context('./images/title', false)
    ),
  },
  [hAreaCodeEnum.hi]: {
    [LotteryStatusEnum.抽中]: getImgSrc(
      'tp恭喜',
      require.context('./images/title', false)
    ),
    [LotteryStatusEnum.空奖励]: getImgSrc(
      'tp抱歉',
      require.context('./images/title', false)
    ),
  },
  [hAreaCodeEnum.hk]: {
    [LotteryStatusEnum.抽中]: getImgSrc(
      'vi恭喜',
      require.context('./images/title', false)
    ),
    [LotteryStatusEnum.空奖励]: getImgSrc(
      'vi抱歉',
      require.context('./images/title', false)
    ),
  },
}

export const EmptyRewardTag = '空奖励'
